import { Navigate } from 'react-router-dom';
import { useRequiredSession } from '@/hooks/useRequiredSession';
import { AppShell } from '@/components/AppShell';
import { SessionGateScreen } from '@/components/SessionGateScreen';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
    const { status, user, retry } = useRequiredSession();

    if (status === 'error') {
        return <SessionGateScreen onRetry={retry} />;
    }

    if (status !== 'ready') {
        return null;
    }

    if (user && !user.onboardingCompleted) {
        return <Navigate to="/onboarding" replace />;
    }

    return <AppShell>{children}</AppShell>;
}
